const asSafeString = (str) => {
	return str
		.toLowerCase()
		.replace(/å/g, "a")
		.replace(/æ/g, "a")
		.replace(/ø/g, "o")
		.replace(/\+/g, "plus")
		.replace(/[^\w\s]/g, "")
		.replace(/\s/g, "-");
};

export default (path, title) => path.replace(/(.+)\/(.+?)\/$/, `$1/${asSafeString(title)}/`);
